import { UiStrings } from "./UiStrings";
import { UiStringsEn } from "./UiStringsEn";

// Arabic translation
export const UiStringsAr: UiStrings = {
  common: {
    dismiss: 'إلغاء',
    close: 'إغلاق',
    continue: 'متابعة',
    back: 'رجوع',
    xp: 'XP',
    explain: 'شرح',
    and: 'و',
    or: 'أو',
    secShort: 'ث',
    minShort: 'د',
    saveChanges: 'حفظ التغييرات',
    logout: 'خروج',
    ago: 'منذ',
    yes: "نعم",
    no: "لا",
    translate: "ترجمة",
    saveTerm: 'حفظ الكلمة',
    tryAgain: "حاول مرة أخرى",
    pleaseWait: "يرجى الإنتظار",
    checkAgainLater: "تحقق مرة أخرى لاحقا",
    errors: {
      tooManyRequests: "لقد استخدمت هذا أكثر من مرة, يرجى المحاولة مرة أخرى لاحقا.",
    }
  },
  nav: {
    header: {
      tabs: {
        workbook: 'المهام',
        contacts: 'المتابعين',
        feed: 'المتابعين',
        recent: 'الأحدث',
        games: 'الألعاب',
      }
    },
    bottomBar: {
      home: 'الرئيسية',
      contacts: 'جهات الاتصال',
      feed: 'التغذية',
      inbox: 'المهام',
      vocab: 'المفردات',
    }
  },
  tryit: {
    existingUsersLogin: 'تسجيل الدخول للمستخدمين الموجودين',
  },
  login: {
    title: 'تسجيل الدخول',
    welcome: 'مرحبا بك في التطبيق',
    requestCodeButton: 'طلب رمز الدخول',
    requestCodeInfo: 'استخدم تليغرام أو البريد الإلكتروني لطلب رمز الدخول الذي يجب أن تقوم بإدخاله هنا.',
    codeInputLabel: 'رمز التحقق',
    verifyCodeButton: 'تحقق الرمز',
    verifying: 'يتم التحقق...',
    codeInputPlaceholder: 'رمز من تليغرام',
    codeEmailInputPlaceholder: 'رمز من البريد الإلكتروني',
    codeInputError: 'رمز غير صالح',
    codeInputSuccess: 'تم التحقق بنجاح',
    cancel: 'إلغاء',
    emailInputLabel: 'عنوان البريد الإلكتروني',
    emailInputPlaceholder: 'أدخل بريدك الإلكتروني',
    sendCodeButton: 'إرسال الرمز',
    sendingCode: 'جارٍ الإرسال...',
    checkEmail: 'تحقق من بريدك الإلكتروني للحصول على رمز المصادقة',
    codeExpiresIn: 'ينتهي الرمز في',
    resendCode: 'إعادة إرسال الرمز',
    selectNativeLanguage: 'اختر لغتك الأم',
  },
  landing: {
    demoChat: {
      tagline: 'تدريب التحدث مع الآلة 🎤👂💥',
      correction: 'تصحيح',
      responseOptions: 'خيارات الرد',
    },
    testimonials: {
      title: 'ما يقوله المستخدمين',
    },
    learningMotivation: {
      title: 'مفيد في أنواع مختلفة من المواقف',
    },
    voiceExamples: {
      title: "تعرّف على محادثات الذكاء الاصطناعي AI",
      detail: "تدرّب مع مدرسين صوتيين ذكيين يستخدمون أصواتًا بشرية طبيعية، لتجربة تعلم أي لغة.",
      listen: "استمع",
      pause: "توقف",
      playing: "يتم تشغيل...",
      info: {               
        title: "تعلّم التحدث بأسلوب طبيعي مع مدرّسين صوتيين ذكيين يستخدمون أصواتًا بشرية واقعية.",
        chip1: "مواضيع مرنة",
        chip2: "أدوات التعلم",
        chip3: "تقييم مفصل",
        chip4: "أصوات حقيقية",
      },
      leadOut: "يستخدم مدرسو الذكاء الاصطناعي نماذج صوتية عالية الجودة تبدو طبيعية، ويستجيبون لك في الوقت الحقيقي."
    },
    betterWithTelegram: {
      title: "أفضل مع تيليغرام",
      info: "يتم دمج مدرسنا الذكاء الاصطناعي مع تيليغرام ويمكنه الاستجابة لأي رسالة ومساعدتك في تتبع التدريب والامتحانات.",
      info2: "سيكون البوت الذي يتم توصيله بتيليغرام أصدقاؤك الموثوق لتعلمك للغة العربية.",
    },
    videoCarousel: {
      practiceStart: "اختر مجموعة من المواضيع والألعاب أو استخدم أفكارك 💡",
      fluencyMeter: "مقياس التحديد الحقيقي يتتبع تقدمك ⏱️",
      tapTranslations: "كلمات غير معروفة؟ انقر على أي رسالة لترجمتها 🌐",
      responseOptions: "تدريب بدون ضغوط مع اقتراحات الرد من الذكاء الاصطناعي 😌",
    },
    knowledgeBase: {
      title: 'الموارد التعليمية', 
      info: 'لبعض اللغات، Chatlanga يقدم موارد تعليمية تناسب الناس الذين يتحدثون اللغة العربية.',
      info2: 'قاعدة المعرفة المتزايدة عبارة عن مجموعة من المقالات والاختبارات وتمارين الاستماع على مختلف المواضيع والجوانب اللغوية للغة.',
    }
  },
  dashboard: {
    progress: {
      title: 'التقدم',
      description: 'تتبع تقدمك في اللغة',
      currentRank: 'التقدم الحالي',
      nextRank: 'التقدم القادم',
      practicesTaken: 'تمت التدريبات',
      examsTaken: 'تمت الامتحانات',
      wordsLearned: 'تعلمت الكلمات',
      vocabSize: 'حجم القاموس',      
    },
    practice: {
      title: 'المكالمة الصوتية',
      description: 'تدريب لغتك مع جلسات التدريب الخاصة بنا',
    },
    chatPractice: {
      title: 'الدردشة الصوتية',
      description: 'تدريب لغتك مع جلسات التدريب الخاصة بنا',
    },
    exam: {
      title: 'الامتحان',
      description: 'أخذ امتحان اللغة مع جلسة الامتحان الخاصة بنا',
      notAvailable: 'لم يكتمل بعد...',
    },
    corrections: {
      title: 'الأخطاء الأخرى',
      description: 'عرض أخطاءك الأخرى',
      noMistakes: 'لا أخطاء! جيد!',
      noSessions: 'حاول جلسة التدريب الأولى لتعلم اللغة!',
      dismissing: 'إلغاء التصحيح...',
      originalPhrase: 'الجملة الأصلية',
      correction: 'التصحيح',
      comment: 'التعليق',
      showMore: 'عرض الكل',
      showLess: 'عرض أقل',      
    },
    vocabulary: {
      title: 'القاموس الجديد',
      description: 'عرض القاموس الجديد',
      buttonLearn: 'تعلم',
      buttonDismiss: 'إلغاء',
      originalPhrase: 'الجملة الأصلية',
      updating: 'يتم تحديث القاموس...',
    },
    recentConversations: {
      title: 'المحادثات الأخرى',      
      noSessions: 'لا يوجد محادثات حتى الآن. حاول تدريب محادثة!',            
    },
    chatExercises: {
      title: 'تمارين الدردشة',
      info: 'احصل على تمرين عشوائي من مدرس الذكاء الاصطناعي في تليغرام',
      send: 'إرسال',
      more: 'أكثر',
    },
    articles: {
      title: 'المقالات المساعدة',
    },
    rewards: {
      title: 'الجوائز',
      noRewards: 'لا يوجد جوائز حتى الآن',
    },
  },
  creditsInfo: {
    credits: 'الائتمانات',    
    one_credit: 'الائتمان',
    many_credits: 'الائتمانات',
    inflectCredits: function(count: number, form: 'nominative' | 'genitive' | 'dative' | 'accusative' | 'instrumental' | 'prepositional') {
      if (count === 1) {
        return `${this.one_credit}`;
      }
      return `${this.many_credits}`;
    },
    buyMoreCredits: 'شراء المزيد',
  },
  languages: {
    title: 'إعدادات اللغة',
    backToDashboard: 'العودة لللوحة التحكم',
    appLanguage: 'اللغة الخاصة بالتطبيق',
    selectLanguageLabel: 'اختر اللغة التي تريد تعلمها:',
    messages: {
      levelNotAvailable: 'المستوى غير متاح',
      levelNotAvailableDescription: '⏳ قريباً متاحًا في أيام قليلة! لا يوجد مدرس لهذا المستوى بعد.',
    }
  },
  examDetails: {
    spanish: {
      oral: {
        beginner: {
          instructions: 'سيعطيك أحد الموضوعات التالية للمحادثة الموجودة في الصوت. سيكون لديك 10 دقائق للتحضير للمحادثة الموجودة في الصوت. بعد ذلك، سيتم عرض صورة يجب أن تصفها.',
        },
        beginnerIntermediate: {
          instructions: '',
        },
        intermediate: {
          instructions: '',
        },
        advanced: {
          instructions: '',
        },
      }
    },
    german: {
      oral: {
        beginner: {
          instructions: 'سيعطيك أحد الموضوعات التالية للمحادثة الموجودة في الصوت. سيكون لديك 10 دقائق للتحضير للمحادثة الموجودة في الصوت. بعد ذلك، سيتم عرض صورة يجب أن تصفها.',
        },
        beginnerIntermediate: {
          instructions: '',
        },
        intermediate: {
          instructions: '',
        },
        advanced: {
          instructions: '',
        },
      }
    }
  },
  exam: {
    stages: {
      monologue: 'Monologue',
      dialogue: 'Dialogue',
      describing: 'Image Describing',
    },
    scoreComponents: {
      hollistic: 'Hollistic',
      corrections: 'Grammar',
      fluency: 'Fluency',
      reach: 'Reach',
      coherence: 'Coherence',
    },
    completed: {
      sendSummary: 'Send Summary',
      overall: {
        title: 'Overall',
      },
      stageScores: {
        title: 'Scores by Stage',
        max: 'Max',
        mean: 'Mean',
      },
      skills: {
        title: 'Skills Assessment',
        detail: 'Scale: 1-10',
      },
      observations: {
        title: 'Observations',
        emptyCategory: 'No observations in this category',
      },
      corrections: {
        title: 'Corrections',
        emptyList: 'No corrections detected',
      }
    }
  },
  beforeConversation: {
    silencePlease: "ابحث عن بيئة منعزلة",
    silenceInfo: "تأكد من أنك في غرفة منعزلة وأنه لا يوجد شخص يتحدث بالقرب منك",
  },
  beforeExam: {
    title: 'المحادثة المحاكاة',
    approximateSimulation: 'المحاكاة تقريبية',
    examDurationMinutes: 'د',
    tutorLabel: 'المحادثة مع:',
    yourTicket: 'الموضوعات الخاصة بك:',
    welcome: function(firstName: string) {
      return `مرحبا, ${firstName}!`;
    },
    audioPermissions: {
      title: 'الصوت المسموع',
      ensurePermissions: 'تأكد من أن لديك ميكروفون وأذناب أو أجهزة الصوت:',      
    },
    examStages: {
      monologue: 'المحادثة الموجودة في الصوت',
      dialogue: 'المحادثة الموجودة في الصوت',      
    },
    startExam: "ابدأ المحادثة",
    startFirstStage: "ابدأ",
  },
  beforePractice: {
    title: 'الوقت للتدريب!',
    tutorShortIntro: 'المدرس الخاص بك:',
    connectingWith: 'يتم الاتصال ب',
    welcome: function(firstName: string) {
      return `مرحبا, ${firstName}!`;
    },
    notEnoughCredits: 'أضف الائتمانات',
    muteNotice: 'يرجى التأكد من أن 🔇 => 🔊 غير متوقف عن الصوت في علامة التبويب الخاصة بك.',
    audioPermissions: {
      title: 'الصوت المسموع',
      ensurePermissions: 'تأكد من أن لديك ميكروفون وأذناب أو أجهزة الصوت:',      
    },
    configurePractice: "تأكيد التدريب",
    startPractice: "ابدأ",
    settings: {
      title: 'تأكيد التدريب',
      motherLanguage: 'اللغة الأم',
      targetLanguage: 'اللغة التي تريد تعلمها',
      languageLevel: 'مستوى اللغة',
      continue: 'ابدأ التدريب',
      edit: 'تعديل',
    },
    userGoals: {
      default: 'التحدث',
      exam: 'المحادثة المحاكاة',
      travelTo: 'السفر/التحويل',
      jobInterview: 'العمل/الترقية',
      relationship: 'اللغة العائلية',
      rentApartment: 'الإيجار',
      talkToAccountant: 'المالية والضرائب',
      talkToDoctor: 'في الطبيب',
      escapeRoom: 'غرفة الإنقاذ',
      treasureHunt: 'البحث عن الكنز',
      grammarExercises: 'تمارين الجراحة',
      practiceIntro: 'المرحبة',
      wordGame: 'لعبة الكلمات',
      custom: 'اكتب الخاص بك...',
    }
  },
  userGoalsDialog: {
    title: 'ما هو أهدافك في التدريب؟',
    subtitle: 'اختر أهداف التدريب لتخصيص المحادثة مع المدرس',
    customGoal: 'أهدافك الشخصية',
    customGoalPlaceholder: 'تحدث مع أصحاب الفرقة في فورتنايت',
  },
  audioPermissions: {
    enableMicrophone: 'تمكين الميكروفون وإلغاء الصمت',
    clickToFix: 'اضغط لإصلاح',
    microphone: 'الميكروفون',
    microphoneNotEnabled: 'الميكروفون غير ممكن, اضغط على الزر لتمكينه:',
  },
  audioDeviceSelector: {
    microphone: 'الميكروفون',
    speakers: 'الأذناب أو الموسيقى:',
    muteNote: 'يمكنك إلغاء الصمت أيضًا في علامة التبويب الخاصة بك *',
  },
  topicSelection: {
    title: 'اختر موضوع',
    instructions: "اضغط على الزر لاختيار موضوع عشوائي.\n سيكون لديك 10 دقائق للتحضير للمحادثة.",
    button: 'رسم موضوع',
    info1: "تتكون المحاكاة الاختبارية من جزأين: 1) مقدمتك ومحادثة موجودة في الصوت على موضوع معين, و 2) محادثة مع المدرس, حيث سيطرح عليك أسئلة داخل سياق مستثني.",
    info2: "سيكون لديك 10 دقائق للتحضير للمحادثة, بعد ذلك سيبدأ المحادثة. يمكنك إلغاء الإنتظار وبدء المحادثة مبكرًا إذا كنت تريد ذلك.",
    skipWait: 'ابدأ',
    anotherTopic: 'موضوع آخر',
    topicDescription: 'الوصف',
    topicInstructions: 'التعليمات',
  },
  examFlow: {
    describeImage: {
      defaultInstruction: "وصف الوضع الموضح في هذه الصورة",
    }
  },
  rating: {
    title: 'شكرا لك على العرض التقديمي!',
    nextUp: 'التالي:',
    conversation: 'تقييم المهارات المحادثية',
    continue: 'استمر',
  },
  conversationInterface: {
    start: 'ابدأ',
    abort: 'إلغاء',
    continue: 'استمر',
    pleaseWait: 'يرجى الإنتظار...',
    stageNames: {
      intro: 'المقدمة',
      monologue: 'المحادثة الموجودة في الصوت',
      dialogue: 'المحادثة الموجودة في الصوت',
      practice: 'التدريب',
    },
    conversationState: {
      ready: 'مستعد للبدء',
      inProgress: 'المحادثة في التقدم',
      clickToEnd: 'اضغط على الزر لإنهاء المحادثة',
      clickToStart: 'اضغط على الزر لبدء المحادثة',
    },
    countdown: {
      timeLeft: 'الوقت المتبقي:',
      timeUp: 'أنت تقريبا قد انتهيت, انهي وابدأ!',
      timeLeftToPrepare: 'الوقت المتبقي للتحضير:',
    }
  },
  practiceSessionBoard: {
    title: 'ملاحظات المدرس',
    transcriptionTitle: 'نص المحادثة',
    yourTurnToSpeak: 'أنت تحتاج إلى التحدث',
    mistakesDetected: 'الأخطاء المكتشفة',
    vocab: {
      title: 'القاموس الجديد',
      dismissKnown: 'إلغاء',
      willBeSent: 'سيتم إرسال هذا بعد التدريب',
      emptyList: 'لا يوجد قاموس جديد حتى الآن',
    },
    corrections: {
      title: 'التصحيحات',
      dismiss: 'إلغاء',
      willBeSent: 'سيتم إرسال هذا بعد التدريب',
      emptyList: 'لا يوجد تصحيحات حتى الآن',
    },
    history: {
      title: 'التاريخ',
      emptyList: 'لا يوجد محادثات حتى الآن',
      you: 'أنت',
      tutor: 'المدرس',
    },
  },
  footer: {
    support: 'الدعم',
    checkWebsite: 'تحقق من موقعنا',
    privacyPolicy: 'السياسة الخاصة',
    termsOfService: 'الشروط والأحكام',
    acceptTerms: 'أنا أوافق على الشروط والأحكام والسياسة الخاصة',
  },
  profile: {
    referral: {
      title: 'دعوة الأصحاب واحصل على الائتمانات',
      description: 'شارك رابط الدعوة الخاص بك مع أصحابك. عندما يسجلون, سيحصل كلاهما على ائتمانات إضافية!',
      copied: 'تم النسخ!',
      copy: 'نسخ',
      invitedCount: function(count: number) {
        return `لقد دعوت ${count} أصحاب حتى الآن!`;
      },
    },
    personal: {
      title: 'البيانات الشخصية',
      firstName: 'الاسم',
      lastName: 'اللقب',
      telegramUsername: 'اسم المستخدم في تلغرام',
      notConnected: 'غير متصل',
      telegramLinked: 'متصل بحساب تلغرام',
    },
    notifications: {
      title: 'الإشعارات',
      practiceReminders: 'تذكيرات التدريب عبر تلغرام',
      practiceRemindersDescription: 'تلقي تذكيرات للتدريب عبر بوت تلغرام',
      reminderFrequency: 'تكرار التذكير',
      frequentDaily: 'متكرر (يومي)',
      moderateWeekly: 'معتدل (2-3 مرات في الأسبوع)',
      rareWeekly: 'منتظم (أسبوعي)',
    },
    chatResponses: 'الإجابات المتاحة للدردشة اليوم',
    deleteAccount: {
      deleteButton: 'حذف الحساب',
      deleteButtonInfo: 'سيتم حذف حسابك وجميع البيانات الخاصة بك. قد يستغرق الأمر حتى 6 أيام للتمكين.',
      deleteConfirmation: 'تأكيد: هل أنت متأكد من حذف حسابك؟ لا يمكن التراجع عن هذا الإجراء!',
    },
    tutorials: {
      resetButton: 'إعادة تعيين التعليمات',
      resetButtonInfo: 'سيتم إعادة تعيين جميع التعليمات المرئية (رسائل التعليمات في الأسفل) وسيتم إعادة عرضها على الأقل مرة واحدة.',
      notifications: {
        tutorialsReset: 'تعليمات التعلم تم إعادة تعيينها',
      }
    }
  },
  assessmentLoading: {
    title: 'التقييم في التقدم',
    subtitle: 'يرجى الإنتظار حتى نكتمل معك النتائج...',
    stateComplete: 'مكتمل',
    step1Label: 'جمع النص',
    step2Label: 'تحليل الجراحة',
    step3Label: 'تصنيف القاموس',
    step4Label: 'تصنيف التحديد',
    step5Label: 'إنشاء التصحيحات',
    step6Label: 'إنشاء التوصيات',
  },
  assessmentDetails: {
    title: 'تفاصيل التقييم',
    practice: 'التدريب',
    monologue: 'المحادثة الموجودة في الصوت',
    dialogue: 'المحادثة الموجودة في الصوت',
    grammar: 'الجراحة',
    vocabulary: 'القاموس',
    fluency: 'التحديد',
    fluencyChart: 'التحديد في هذه المحادثة',
    pronunciation: 'التحديد',
    overall: 'المجموع',
    corrections: 'التصحيحات',
  },
  practiceCompleted: {
    tryAgainButton: 'حاول مرة أخرى',
    sendSummaryButton: 'إرسال الملخص',
    firstTryIssues: {
      info1: "لقد لاحظنا أن لديك بعض المشاكل! هذا في الواقع جيد! إذا لم تعرف كيفية قول شيء ما، يمكنك التحدث بلغتك الأصلية.",
      info2: "اضغط على الرسائل لترجمتها إلى اللغة الأصلية.",
      info3: "لا تقلق! نقدم لك إعادة محاولة مجانية، فقط ابدأ جلسة تدريب جديدة الآن:",
      retryButton: "إعادة محاولة مجانية الآن",
    },
    creditsLeft: (credits: number) => `لديك ${credits} ${UiStringsAr.creditsInfo.inflectCredits(credits, 'genitive')} متبقية`,
    tryGameModes: "جرب وضعيات اللعب المتحدة:",
    tryWithCreditsInfo: (credits: number, sessionsLeft: number, price: number) => `باستخدام ${credits} ائتمانات، يمكنك جرب ${sessionsLeft} مرة أخرى! في نهاية كل جلسة، سيتم خصم ${price} ائتمانات.`,
  },  
  converationAudioIssues: {
    title: "لم يتم الكشف عن الصوت",
    noSpeechDetected: "لم يتم الكشف عن الصوت خلال جلسة التدريب. يمكن أن يكون هذا ناتجًا عن مشاكل تقنية مع تكوين الميكروفون الخاص بك.",
    pleaseCheck: "يرجى التحقق من التالي:",
    ensureSilentModeOff: "تأكد من أن موقع الصمت لجهازك معطل والصوت ممكن",
    ensureMicrophoneEnabled: "تأكد من أن الميكروفون ممكن في إعدادات المتصفح",    
    checkHeadset: "تأكد من أنك تستخدم <b>أذناب أو أجهزة الصوت الخارجية</b> ولكن لا يمكنك استخدام كلاهما",
    ensureTabNotMuted: "تأكد من أن علامة التبويب لم يتم إلغاء الصمت",
  },
  onboarding: {
    title: "المعلومات الشخصية",
    welcome: "تخصيص تجربتك في التعلم",
    continue: "استمر",
    welcomeSubtitle: "ابدأ رحلتك في التحديد",
    welcomeInfo: "قم بتعبئة النموذج للبدء. سيتم تحديد كل جزء عند الانتهاء من السابق.",
    personalInfo: {
      title: "المعلومات الشخصية",
      firstName: "الاسم",
      firstNameInfo: "ستستخدم المدرسون هذا الاسم للإشارة إليك",
      firstNamePlaceholder: "اسمك",
      lastName: "اللقب",
      lastNamePlaceholder: "لقبك",
    },
    languageInfo: {
      title: "التفضيلات في التعلم",
      subtitle: "",
      motherLanguage: "اللغة الأم",
      motherLanguageInfo: "سيتم استخدام هذه اللغة للتوجيهات والواجهة",
      targetLanguage: "اللغة التي تريد تعلمها",
      languageLevel: "مستوى اللغة",
    },
    learningMotivation: {
      title: "الدافع للتعلم",
      subtitle: "لماذا قررت تعلم هذه اللغة؟",
      options: {
        relocation: "التحويل",
        exam: "الاختبار",
        travel: "السفر",
        relationship: "العلاقة",
        career: "الوظيفة",
        family: "العائلة",
        other: "أكثر من ذلك!",
      },
    },
    learningGoals: {
      title: "أهداف التعلم",
      subtitle: "ما هي أهدافك في التعلم؟",
      options: {
        fluency: "تحسين التحديد",
        vocab: "تعلم المزيد من الكلمات",
        idioms: "اللغات الأصلية",
        anxiety: "التخلص من القلق",
        job: "الحصول على وظيفة",
        other: "أكثر من ذلك!",
      },
    },
    learningSchedule: {
      title: "التسجيل المنتظم للتدريب",
      subtitle: "<b>ملاحظة:</b> يعمل التطبيق بشكل أفضل عندما تتدرب قليلاً (حتى 5 دقائق) كل يوم، بدلاً من جلسات طويلة أقل تكرار.",
      question: "كم مرة يمكنك أن تخطط للتدريب؟",
      options: {
        few_times_per_day: "بعض المرات في اليوم",
        once_per_day: "مرة واحدة في اليوم",
        few_times_per_few_days: "بعض المرات في الأسبوع",
        idk: "لا أعلم",
        other: "أكثر من ذلك!",
      }
    },
    termsOfService: {
      title: "الإشعار القانوني",
      termsOfService: "الشروط والأحكام",
      privacyPolicy: "السياسة الخاصة",
      acceptTerms: "أنا أوافق على الشروط والأحكام والسياسة الخاصة",
      confirmAge: 'أنا أكبر من 16 عامًا',
      confirmAgeInfo: 'بعض الدول تتطلب أن تكون المحادثات الذكائية مقتصرة على المستخدمين الذين يبلغون من العمر 16 عامًا أو أكثر.',
    },
    completeSetup: "ابدأ التعلم",
  },
  examStatus: {
    title: 'شكرا لك على المحادثة المحاكاة!',
    postExamInfo: "تم إكمال جلسة المحادثة المحاكاة بنجاح. \nنأمل أن تكون هذه التجربة مفيدة لتحسين مهارات التحديد.",
    quickAssessment: {
      pleaseWait: 'يرجى الإنتظار حتى نكتمل معك النتائج...',
      title: 'التقييم السريع',
      monologue: 'التقييم الموجود في الصوت',
      dialogue: 'التقييم الموجود في الصوت',
      grammar: 'الجراحة',
      vocabulary: 'القاموس',
      fluency: 'التحديد',
      totalScore: 'النتيجة الكلية',
      feedback: 'التغذية الرجعية:',
    },
    recordings: {
      title: 'التسجيلات الخاصة بك',
      monologue: 'التسجيل الموجود في الصوت',
      dialogue: 'التسجيل الموجود في الصوت',
      pleaseWait: 'يتم إنشاء التسجيل...',
    },
    thankYou: {
      title: 'شكرا لك على المحادثة المحاكاة!',
      reloadLater: "يمكنك تغيير علامة التبويب الأخرى ولكن لا تغلق هذه الصفحة. قم بتحميل الصفحة لاحقًا للحصول على تقييم المدرس الكامل.",
    }
  },  
  practiceResponseOptions: {
    title: 'إرشادات الإجابة',
    disabledTitle: 'إرشادات',
    dismiss: 'إلغاء',
    loading: 'يتم التحميل...',
    noOptions: 'لم يتم العثور على خيارات',
    tutorSaid: 'قال المدرس:',
    enable: 'On',
    disable: 'Off',
  },
  balance: {
    buyMoreCredits: 'شراء المزيد',
    startCheckout: 'الذهاب إلى الدفع',
    thanks: 'شكرا لك على الشراء!',
    purchaseSuccessful: 'تم الشراء بنجاح',
    aboutCredits: {
      title: 'كيف يمكن استخدام الائتمانات؟',
      details: 'يتم استخدام الائتمانات لشراء خدمات مبنية على الذكاء الاصطناعي في تطبيق Chatlanga. يتطلب استخدام موديلات عالية الجودة وإنشاء الصوت المتميز عالية القدرة الحسابية 💪 ونحن نعمل بجد للحفاظ على سلاسة العمل.',
      services: {
        practice: {
          title: 'تدريب التحديد',
          detail: 'جلسة تدريب 5 دقائق مع مدرس صوتي عالي الجودة',
        },
        exam: {
          title: 'جلسة الاختبار',
          detail: 'محاكاة الاختبار بثلاثة أجزاء: المقدمة, المحادثة الموجودة في الصوت والوصف',
        },
        chatPackStandard: {
          title: 'الحزمة الأساسية للإجابة',
          detail: '50 إجابة ذكية من مدرسنا الذكي في تلغرام',
        },
        chatPackPremium: {
          title: 'الحزمة الممتازة للإجابة',
          detail: '200 إجابة ذكية من مدرسنا الذكي في تلغرام',
        }
      }
    }
  },
  coupons: {
    couponForm: {
      title: 'تفعيل الكوبون',
      codeLabel: 'كود الكوبون الخاص بك',
      codePlaceholder: 'أدخل كود الكوبون',
      submitButton: 'تطبيق',
    },
    modal: {
      title: 'تم تفعيل الكوبون!',
      detail: 'تم تطبيق كود الكوبون بنجاح.',
      defaultMessage: 'تم إضافة الائتمانات إلى حسابك.',
    },
    errors: {
      notFound: 'لم يتم العثور على الكوبون',
      alreadyClaimed: 'تم تفعيل الكوبون بالفعل',
      failedToClaim: 'فشل تفعيل الكوبون',            
    }
  },
  support: {    
    tabs: {
      articles: 'المقالات المساعدة',
      myTickets: 'طلباتي',
    },
    articles: {
      title: 'الأسئلة الشائعة',
      botChatInfo: 'لا تكن مترديا واستفسر من خلال زر الدردشة الخاص بنا في تلغرام! يمكنه تقديم الدعم الأساسي ورفع حالتك إذا لزم الأمر.',
      telegramSupport: 'احصل على الدعم في تلغرام',
    },
    ticketForm: {
      title: 'إرسال طلب',
      email: 'البريد الإلكتروني',
      emailPlaceholder: 'البريد الإلكتروني الخاص بك...',
      topic: 'الموضوع',
      topicPlaceholder: 'المشكلة أو الاقتراح...',
      type: 'نوع الطلب',
      typePlaceholder: 'حدد نوع الطلب',
      requestType: {
        bug: 'الخطأ',
        suggestion: 'الاقتراح',
        featureRequest: 'طلب الميزة',
        other: 'أخرى',
      },
      message: 'الرسالة',
      messagePlaceholder: 'وصف المشكلة أو الاقتراح...',
      submitButton: 'إرسال',
      submitted: 'تم إرسال الطلب بنجاح!',
    },
    myTickets: {
      title: 'طلباتي',
      createTicket: 'إنشاء طلب',
      noTickets: 'إذا أردت الحصول على المساعدة, اضغط على الزر أدناه لإنشاء طلب دعم جديد:',
      createTicketButton: 'إنشاء طلب',
      ticketList: {
        open: 'مفتوح',
        inProgress: 'في التقدم',
        closed: 'مغلق',
      },
    }
  },
  pushToTalk: {
    defaultLabel: 'الضغط والتحديد',
    recording: 'إطلاق الصوت',
    processing: 'أنت تحتاج إلى الإنتظار...',
    speakNow: 'قل الآن...',
  },
  soundTest: {    
    title: "اختبار الصوت",
    instructionPrefix: "قل:",
    testPhrase: "أنا جاهز للبدء",
    confirmationQuery: "هل سمعت الإجابة؟",
    successMessage: "تم اختبار الصوت بنجاح!",
    micError: "تأكد من أن لديك إذن لاستخدام الميكروفون وتحقق من أن لديك أي أجهزة Bluetooth إضافية توصيلة",
    tabMutedError: "🔇 => 🔊 تأكد إذا كان علامة التبويب مغلقة!",
  },
  chatSpeechMeter: {
    info: function(wpm: number, minWpm: number, maxWpm: number, levelName: string) {
      return `تتحدث بمعدل ≈${wpm} كلمة في الدقيقة. لمستوى ${levelName} المتوقع هو ${minWpm} - ${maxWpm} كلمة في الدقيقة.`;
    }
  },
  voiceChat: {
    chatFlow: { 
      title: "الدردشة الصوتية",
      playbackRate: "سرعة التشغيل الصوتي",
      messagePlaceholder: "اكتب رسالتك...",
      hints: {
        pushToTalk: "اضغط أو اضغط للتحديد",
        emotions: "اختر موضوع التحديد للتعبير عن كيفية تحديدك!",
      },
      history: {
        assist: "مساعدة",
        notes: "ملاحظات",
      },
      limitNoice: {
        title: "الحد اليومي المحدث",
        detail: "⏳ لقد وصلت إلى الحد اليومي للإرسال. يرجى الإنتظار حتى الظهر لتحديث الحدود.",
      }
    },
    inventory: {
      manager: {
        title: "المخزن",
      },
      itemDetails: {
        acquiredInMessage: "المحصول في السياق:",
        emptyList: "العناصر التي يمكن استخدامها في الدردشة أو التي تحصل عليها أثناء الدردشة سيتم عرضها هنا.",
        itemReceived: "العنصر المحصول",
        itemLost: "العنصر المحصول",
      },
    },
    panels: {
      wordCounter: {
        title: "الكلمات",
      },
      progress: {
        title: "التقدم",
      },
      lives: {
        title: "الحياة",
      },
    },
  },
  todoLists: {
    dashboardTitle: "المهام الخاصة بك",
    currentTask: "المهمة",
    item: {
      status: {
        completed: "مكتمل",
      }
    },
    drawer: {
      defaultLabel: "مهمة تعليمية",
      loading: "يرجى الإنتظار حتى يقوم المدرس بإعداد ملاحظات المهمة...",
    },
    modals: {
      taskCompleted: {
        title: "مهمة مكتملة",
        continueLearning: "متابعة التعلم",
      },
      taskCreated: {
        title: "مهمة جديدة",
      },
      rewardReceived: {
        title: "جائزة جديدة",
      },
    }
  },
  imageOverlay: {
    zoomTip: "اضغط للتقريب • اضغط للتقريب",
  },
  feed: {
    miniChallengeButton: "التحدي الصغير",
    loader: {
      title: "تحميل المنشورات الجديدة",
      subtitle: "إعداد محتوى شخصي لك",
    },
    waitToLoadMore: {
      title: "ابدأ بمراجعة المنشورات الحالية أولا!",
      subtitle: "يرجى التحقق من المنشورات الحالية بثلاث ثوانٍ قبل تحميل المزيد",
    },
    addingContact: {
      title: "إضافة الاتصال",
      subtitle: "لديك اتصال افتراضي جديد!",
    },
    giftBox: {
      openMode: {
        hits: {
          title1: "اضغط عدة مرات للفتح",
          title2: "الغرفة المفتوحة!",
          title3: "جائزة الصدفة!",
        }
      },
      note: "الغرف المرسومة تحتوي على اتصالات جديدة, عناصر مفيدة وغيرها من الجوائز!",
    }
  },
  quizForm: {
    correct: "صحيح: ",
    correctCount: "صحيح: ",
    incorrectCount: "خطأ: ",
    quizCompleted: "تم الاختبار",
    quizCompletedDetail: "لقد إنتهيت من الاختبار. يمكنك إعادة المحاولة لتحسين نتيجتك.",
    repeatQuiz: "إعادة الاختبار",
  },
  contacts: {
    newContactsNote: 'احصل على اتصالات جديدة بالعثور على اتصالات جديدة في "المتابعين"! قراءة المقالات وحل الاختبارات لاكتشاف 🎁 غرف الهدايا!',
    contactTasks: 'المهام',
    startTaskChat: 'ابدأ المهمة',
  },
  experienceBar: {
    gameLivesHint: 'أحياء اللعبة',
    rankHint: 'مستوى الطالب',
    xpLeftToNextLevel: 'XP متبقي للمستوى التالي',
    xpGained: 'XP المكتسب',
  },
  vocabularyPage: { 
    vocabListTitle: 'قاموسك',
    shortTitle: 'قاموسك',
    emptyList: 'لا يوجد قاموس محفوظ بعد. استخدم زر "حفظ" في شرح الكلمات لإضافة كلمات إلى قاموسك.',
    wordGameButton: 'Flash cube',
  },
  wordGame: {
    cube: {
      title: 'Flash cube',
      questionLabel: 'السؤال',
      translationLabel: 'ترجمة:',
      instruction: 'دورق الكلمات بالماوس أو الإصبع لرؤية كل الخيارات.',
      otherDefinitions: 'القيم الأخرى',
      wordForIncorrectAnswer: 'الكلمة الخاطئة',
    },
    completeModal: {
      title: 'تم الانتهاء!',
      effort: {
        veryLow: 'أووو! 😭',
        low: 'استمر في التدريب! 📚',
        medium: 'جيد جدا! 💪',
        high: 'ممتاز! 🎉',
        veryHigh: 'مثالي! 🌟',
      }
    }
  }
};
